import config from '../../config/config';

import getRequest from './base/get';
// import postRequest from './base/post';

let connectorRatingMockData = [
  {
    id: '1',
    connectorRatingName: 'Connector 3.3 kW',
    type: 'AC',
    maxPowerOutput: '3.3 kW',
    tariffAttached: 1,
    connectorAttached: 1,
    status: true,
    createdAt: '2025-12-12T15:00:00Z',
    updatedAt: '2025-12-14T12:00:00Z',
  },
  {
    id: '2',
    connectorRatingName: 'Connector 7.5 kW',
    type: 'AC',
    maxPowerOutput: '7.5 kW',
    tariffAttached: 0,
    connectorAttached: 0,
    status: true,
    createdAt: '2025-12-12T15:00:00Z',
    updatedAt: '2025-12-14T12:00:00Z',
  },
  {
    id: '3',
    connectorRatingName: 'Connector 15 kW',
    type: 'DC',
    maxPowerOutput: '15 kW',
    tariffAttached: 3,
    connectorAttached: 3,
    status: false,
    createdAt: '2025-12-12T15:00:00Z',
    updatedAt: '2025-12-14T12:00:00Z',
  },
  {
    id: '4',
    connectorRatingName: 'Connector 30 kW',
    type: 'DC',
    maxPowerOutput: '30 kW',
    tariffAttached: 1,
    connectorAttached: 1,
    status: true,
    createdAt: '2025-12-12T15:00:00Z',
    updatedAt: '2025-12-14T12:00:00Z',
  },
  {
    id: '5',
    connectorRatingName: 'Connector 150 kW',
    type: 'DC',
    maxPowerOutput: '150 kW',
    tariffAttached: 2,
    connectorAttached: 2,
    status: false,
    createdAt: '2025-12-12T15:00:00Z',
    updatedAt: '2025-12-14T12:00:00Z',
  },
];

export default {
  /**
   * Fetch the Basic Information
   * @returns {any} Promise
   */
  fetchConnectorActive: (): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/cpo/v1/end-consumer/get-end-consumer-status`);
  },

  /**
   * Fetch all connector ratings
   * @param {any} parameters parameters
   * @returns {any} Promise
   */
  fetchConnectorRatings: (parameters?: any): Promise<any> => {
    console.log('MOCK API - fetchConnectorRatings called with:', parameters);

    let filteredData = [...connectorRatingMockData];

    if (parameters?.searchBy) {
      filteredData = filteredData.filter((item) =>
        item.connectorRatingName.toLowerCase().includes(parameters.searchBy.toLowerCase()),
      );
    }
    return Promise.resolve({
      data: {
        results: filteredData,

        limit: parameters?.limit || 10,

        page: parameters?.page || 1,

        totalPages: 1,

        totalResults: filteredData.length,
      },
    });
  },

  /**
   * Create connector rating
   * @param {any} data - The rating data to create
   * @returns {any} The create response
   */
  createConnectorRating: (data: any): Promise<any> => {
    console.log('MOCK API - createConnectorRating called with:', data);
    const newRating = {
      id: String(Date.now()),

      connectorRatingName: data.connectorRatingName,

      type: data.type,

      maxPowerOutput: data.maxPowerOutput,

      tariffAttached: 0,

      connectorAttached: 0,

      status: data.status,

      createdAt: new Date().toISOString(),

      updatedAt: new Date().toISOString(),
    };
    connectorRatingMockData = [newRating, ...connectorRatingMockData];
    return Promise.resolve({
      data: {
        message: 'Connector rating added successfully',

        result: newRating,

        status: true,
      },
    });
  },

  /**
   * Edit connector rating
   * @param {any} data - The rating data to edit
   * @returns {any} The edit response
   */
  editConnectorRating: (data: any): Promise<any> => {
    console.log('MOCK API - editConnectorRating called with:', data);

    connectorRatingMockData = connectorRatingMockData.map((item) => {
      if (item.id === data.id) {
        return {
          ...item,

          connectorRatingName: data.connectorRatingName,

          type: data.type,

          maxPowerOutput: data.maxPowerOutput,

          status: data.status,

          updatedAt: new Date().toISOString(),
        };
      }

      return item;
    });

    return Promise.resolve({
      data: {
        message: 'Connector rating updated successfully',

        status: true,
      },
    });
  },

  /**
   * Delete connector rating
   * @param {any} id - The rating ID to delete
   * @returns {any} The delete response
   */
  deleteConnectorRating: (id: string): Promise<any> => {
    console.log('MOCK API - deleteConnectorRating called with:', id);

    connectorRatingMockData = connectorRatingMockData.filter((item) => item.id !== id);

    return Promise.resolve({
      data: {
        message: 'Connector rating deleted successfully',
        status: true,
      },
    });
  },

  /**
   * Fetch connector rating filters
   * @returns {any} Promise
   */
  fetchConnectorRatingFilterList: (): Promise<any> => {
    return Promise.resolve({
      data: [],
    });
  },

  /**
   * Fetch the all connector rating list
   * @returns {any} Promise
   */
  fetchConnectorRatingAllList: (): Promise<any> => {
    return getRequest(`${config.tariffApiUrl}api/cpo/v1/rating/all-list`, {});
  },

  /**
   * Fetch the all connector rating list
   * @param {any} scopeId scope id
   * @returns {any} Promise
   */
  fetchConnectorScopList: (scopeId: string): Promise<any> => {
    return getRequest(`${config.tariffApiUrl}api/cpo/v1/rating/get-scope-list`, {
      scopeId: scopeId || undefined,
    });
  },
};
